import { render, staticRenderFns } from "./RightMenus.vue?vue&type=template&id=3c82a648&scoped=true&"
import script from "./RightMenus.vue?vue&type=script&lang=js&"
export * from "./RightMenus.vue?vue&type=script&lang=js&"
import style0 from "./RightMenus.vue?vue&type=style&index=0&id=3c82a648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c82a648",
  null
  
)

export default component.exports